<template>
  <ui-content title="Liquidaciones">
    <Spinner v-if="loading.view"></Spinner>
    <template v-else>
      <Card title="Filtros" icon="fa fa-filter">
        <div class="row">
          <div class="col-12 col-md-3 col-lg-2">
            <div class="form-group">
              <label for="" class="form-label">Código Liquidación</label>
              <InputText v-model="form.codLiquidacion"></InputText>
            </div>
          </div>
          <div class="col-12 col-md-3 col-lg-2">
            <div class="form-group">
              <label for="" class="form-label">Agencia</label>
              <InputSelect
                v-model="form.agencia"
                :options="agencias"
              ></InputSelect>
            </div>
          </div>
          <div class="col-12 col-md-3 col-lg-2">
            <div class="form-group">
              <label for="" class="form-label">Fecha Inicio</label>
              <InputDatepicker v-model="form.fechaInicio"></InputDatepicker>
            </div>
          </div>
          <div class="col-12 col-md-3 col-lg-2">
            <div class="form-group">
              <label for="" class="form-label">Fecha Fin</label>
              <InputDatepicker v-model="form.fechaFin"></InputDatepicker>
            </div>
          </div>
          <div class="col-12 col-md-3 col-lg-2">
            <div class="form-group">
              <label for="" class="form-label">Pasajero</label>
              <InputText v-model="form.pasajero"></InputText>
            </div>
          </div>
          <div class="col-12 col-md-3 col-lg-2">
            <div class="form-group">
              <label for="" class="form-label">Código Registro</label>
              <InputText v-model="form.codRegistro"></InputText>
            </div>
          </div>
          <div class="w-100"></div>
          <div class="col-12">
            <div class="form-group">
              <input type="checkbox" name="" id="" />
              <label for="" class="form-label ml-2"
                >Mostrar registros sin emisión de comprobante</label
              >
            </div>
          </div>
        </div>
      </Card>
      <Card title="Liquidaciones" :bodyClass="'p-0'">
        <template #toolbar>
          <button
            v-if="marcados.length"
            class="btn btn-outline-success btn-sm mr-2"
            :disabled="loading.emitir"
            @click="onEmitirDocumento"
          >
            {{ loading.emitir ? "Cargando..." : "Emitir Documento" }}
          </button>
          <button class="btn btn-outline-secondary btn-sm" @click="onImprimir">
            Imprimir
          </button>
        </template>
        <LiquidacionesTable />
      </Card>
    </template>
    <LiquidacionDetalleModal
      v-if="containers.modalLiquidacionDetalle.show"
      :record="containers.modalLiquidacionDetalle.record"
      @hide="containers.modalLiquidacionDetalle.show = false"
    />
    <LiquidacionComprobanteModal
      v-if="containers.showLiquidacionComprobanteModal"
      :comprobante="containers.comprobante"
      @hide="onHideLiquidacionComprobanteModal"
    ></LiquidacionComprobanteModal>
  </ui-content>
</template>

<script>
import LiquidacionComprobanteModal from "../components/LiquidacionComprobanteModal.vue";
import InputSelect from "../../shared/components/InputSelect.vue";
import InputDatepicker from "../../shared/components/InputDatepicker.vue";
import InputText from "../../shared/components/InputText.vue";
import Alert from "../../shared/components/Alert.vue";
import LiquidacionDetalleModal from "../components/LiquidacionDetalleModal.vue";
import LiquidacionesTable from "../components/LiquidacionesTable.vue";
import Card from "../../shared/components/Card.vue";
import Spinner from "../../shared/components/Spinner.vue";
import { mapGetters, mapState } from "vuex";
import { BDropdown, BDropdownItemButton } from "bootstrap-vue";

export default {
  components: {
    Spinner,
    Card,
    LiquidacionesTable,
    LiquidacionDetalleModal,
    Alert,
    InputText,
    InputDatepicker,
    InputSelect,
    BDropdown,
    BDropdownItemButton,
    LiquidacionComprobanteModal
  },
  data() {
    return {
      loading: {
        view: true,
        emitir: false
      },
      containers: {
        modalLiquidacionDetalle: {
          show: false,
          record: null
        },
        mode: "normal",
        modalItem: null,
        liquidaciones: [],
        showModalLiquidacionDetalle: false,
        agencias: [],
        showLiquidacionComprobanteModal: false,
        comprobante: {}
      }
    };
  },
  async created() {
    await this.fetchData();
  },
  mounted() {
    this.$root.$on("detail", row => {
      console.log("detail", row);
      this.containers.modalLiquidacionDetalle.record = row;
      this.containers.modalLiquidacionDetalle.show = true;
    });
  },
  computed: {
    ...mapState("liquidaciones", ["form", "agencias"]),
    ...mapGetters("liquidaciones", ["marcados"])
  },
  methods: {
    async fetchData() {
      const vm = this;
      let response;

      vm.loading.view = true;

      try {
        response = await vm.axios.get("/liquidaciones");
      } catch (error) {
        return;
      }

      let agencias = [];

      const liquidaciones = response.data.content.liquidaciones.map(item => {
        if (item.agencia) {
          agencias.push(item.agencia);
        }

        return {
          ...item,
          checked: false,
          fechaDjs: item.fechaHora
            ? vm.$dayjs(item.fechaHora, "YYYY-MM-DD")
            : null
        };
      });

      agencias = [...new Set(agencias)];

      agencias.sort();

      vm.$store.commit("liquidaciones/load", {
        agencias,
        liquidaciones,
        codLiquidacion: this.$route.query?.codLiquidacion || "",
        codRegistro: this.$route.query?.codRegistro || ""
      });

      vm.loading.view = false;
    },
    onUpdatedItem({ item, total }) {
      this.containers.liquidaciones = this.containers.liquidaciones.map(
        liquidacion => {
          if (liquidacion.idLiquidacion == item.idLiquidacion) {
            return {
              ...item,
              suma: total,
              total: total * Number(item.pax)
            };
          }
          return liquidacion;
        }
      );
    },
    async onEmitirDocumento() {
      this.loading.emitir = true;

      try {
        const response = await this.axios.post("/liquidaciones/generar", {
          registros: this.marcados
        });

        this.containers.comprobante = {
          idMoneda: response.data.content.items[0].idMoneda,
          idAgencia: response.data.content.agencia.idAgencia,
          items: response.data.content.items
        };

        this.containers.showLiquidacionComprobanteModal = true;
      } catch (error) {
        console.error({ error: error?.response || error });
      } finally {
        this.loading.emitir = false;
      }
    },
    onHideLiquidacionComprobanteModal(reload) {
      if (reload) {
        window.location.reload();
        return;
      }

      this.containers.showLiquidacionComprobanteModal = false;
    },
    onImprimir() {
      // TODO: hacer impresión
    }
  }
};
</script>

<style></style>
